/*
 * @Author       : yilei
 * @Date         : 2023-01-31 17:38:16
 * @LastEditTime : 2023-03-28 16:32:39
 * @LastEditors  : yilei
 */
const getCookie = function (key: string) {
  const reg = new RegExp('(^| )'.concat(key, '=([^;]*)(;|$)'))
  const arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  }

  return ''
}

const setCookie = (
  name: string,
  value: string,
  expires?: number,
  path?: string,
  domain?: string,
  secure?: boolean
) => {
  // set time, it's in milliseconds
  const today = new Date()
  today.setTime(today.getTime())

  // if the expires variable is set, make the correct expires time, the current script below will set
  // it for x number of days, to make it for hours, delete * 24, for minutes, delete * 60 * 24
  const t = expires ? expires * 1000 * 60 * 60 * 24 : 0
  const expires_date = new Date(today.getTime() + t)

  document.cookie = name + '=' + encodeURIComponent(value) +
    (expires ? ';expires=' + expires_date.toUTCString() : '') +
    ';path=' + (path ?? '/') +
    (domain ? ';domain=' + domain : '') +
    (secure ? ';secure' : '')
}

export { getCookie, setCookie }
